import Swiper from 'swiper';
import {
    Navigation,
    Pagination,
    A11y,
} from 'swiper/modules';

Swiper.use([Navigation, Pagination, A11y]);

let swiperInstance = null;
let init = false;

function swiperMode() {
    let smallBreakpoint = window.matchMedia('(min-width: 0px) and (max-width: 960px)');
    let largeBreakpoint = window.matchMedia('(min-width: 961px)');

    if (smallBreakpoint.matches) {
        if (!init) {
            init = true;
            swiperInstance = new Swiper('.swiper-container.disabled-on-desktop', {
                slidesPerView: 1.1,
                spaceBetween: 16,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                breakpoints: {
                    400: {
                        slidesPerView: 1.2
                    },
                    577: {
                        slidesPerView: 2
                    },
                }
            });
        }
    } else if (largeBreakpoint.matches) {
        if (init && swiperInstance) {
            swiperInstance.destroy(true, true);
            swiperInstance = null;
            init = false;
        }
    }
}

window.addEventListener('load', swiperMode);
window.addEventListener('resize', swiperMode);

document.querySelectorAll('.swiperNewsSlider').forEach(function (thisSlider) {
    const container = thisSlider.closest('.swiperNewsBlock');
    const nextButton = container.querySelector('.swiperNewsNext');
    const prevButton = container.querySelector('.swiperNewsPrev');

    const swiper = new Swiper(thisSlider, {
        modules: [Navigation, A11y],
        a11y: {
            enabled: true
        },
        navigation: {
            nextEl: nextButton,
            prevEl: prevButton,
        },
        breakpoints: {
            0: {
                slidesPerView: 1.2,
                spaceBetween: 16,
            },
            576: {
                slidesPerView: 2.1,
                spaceBetween: 16,
            },
            992: {
                slidesPerView: 3,
                spaceBetween: 16,
            },
            1200: {
                slidesPerView: 4,
                spaceBetween: 16,
            },
        },
    });
});

document.querySelectorAll('.swiperGallerySlider').forEach(function (thisSlider) {
    const container = thisSlider.closest('.swiperGalleryBlock');
    const nextButton = container.querySelector('.swiperGalleryNext');
    const prevButton = container.querySelector('.swiperGalleryPrev');

    const swiper = new Swiper(thisSlider, {
        modules: [Navigation, A11y],
        slidesPerView: 1,
        spaceBetween: 0,        
        a11y: {
            enabled: true
        },
        navigation: {
            nextEl: nextButton,
            prevEl: prevButton,
        },
    });
});